import React, {useRef}  from 'react';
import KidsLifeTopMenu from "./KidsLifeTopMenu";
import {connect} from "react-redux";
import {goHome} from "src/containers/foundation/foundationFunctions";
import {contentURL, makeAppTopMod} from "src/utilities/utilityFunctions";
import store from 'src/store';
import {smallScreenSizes} from "../../../datamodels/gameTime";
import SmallScreenHomeButton from "./SmallScreenHomeButton";
import {gsap,Back,Elastic,Power4} from "gsap";
import SmallScreenMenuPage from "src/components/TDP/HomePage/SmallScreenMenuPage";

const hideMeMods= [
    "components/TDP/TDPHome"
];


const KidsLifeHeader = (props) => {
    const menuModalRef = useRef();
    let stateData = store.getState();
    let largescreen = (["xl","lg"]).indexOf(stateData.appSettings.breakpoint) > -1;
    let nav = smallScreenSizes.indexOf(stateData.appSettings.breakpoint) > -1
        ? <SmallScreenHomeButton/>
        : <SmallScreenHomeButton/>;
        //<KidsLifeTopMenu/>
    let contactStyle = largescreen ? {textAlign:'right',fontSize:'1em'} : {textAlign:'center',fontSize:'1.10em',marginBottom:0};

    const nav2 = hideMeMods.indexOf(stateData.appSettings.appMainModuleName) > -1
    ?
    null
    :
    // <div style={{position:'absolute',top:7,right:8,width:30,height:30,border:'solid 2px #b2b2b2',color:'#999999'}} onClick={()=>blackout()}>
    <div style={{position:'absolute',top:7,right:8,width:30,height:30,border:'solid 2px #0080ff',color:'#0080ff'}} onClick={()=>blackout()}>
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-list" viewBox="-2 -1 16 16">
          <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
        </svg>
    </div>;

    const blackout = () =>{
        let buttonArray = gsap.utils.toArray(".mobileFrontScreenButton");
        let angle = 360/buttonArray.length;

        for (let i = 0; i < buttonArray.length; ++i) {
            gsap.set(buttonArray[i], {rotationY:0,x:-1500*Math.cos(angle*(i)),y:1500*Math.sin(angle*(i)),opacity:0});
        }
        gsap.set(menuModalRef.current, {background:'rgba(0,0,0,0.0)'});

        gsap.set(menuModalRef.current, {display:'grid'});
        gsap.to(menuModalRef.current,1.5,{background:'rgba(0,0,0,0.75)'});
        gsap.to(".mobileFrontScreenButton",.64,{stagger:0,opacity:1,x:0,y:0,scale:1,rotationY:0,rotationZ:0,ease:Back.easeOut});
    }
    const killModal = () =>{
        let buttonArray = gsap.utils.toArray(".mobileFrontScreenButton");
        let angle = 360/buttonArray.length;

        for (let i = 0; i < buttonArray.length; ++i) {
            gsap.to(buttonArray[i],.6, {x:-1500*Math.cos(angle*(i)),y:1500*Math.sin(angle*(i)),ease:Back.easeIn});
        }
        gsap.to(menuModalRef.current,.6,{background:'rgba(0,0,0,0)',onComplete:function(){ gsap.set(menuModalRef.current, {display:'none'}) }});
    }

    if(largescreen){
        return (
            <div id="kidslifeheader" className="t-modified-header" style={{width:"100vw"}}>
                <div className="container">
                    <div className="logo">
                        <img onClick={()=>goHome()} src={contentURL() + "/site/images/TDPLogo.png"} alt="Toddler Dance Party!" title="Toddler Dance Party" id="headerImage" />
                    </div>
                    <div className={largescreen?"contact-details":null}>
                        <p className="mail"  style={contactStyle}>
                            <a href="mailto:dan@toddlerdanceparty.com" id="contactEmail">dan@toddlerdanceparty.com</a>
                            <span className="fa fa-envelope ml-2" />
                        </p>
                        <p className="phone-no" style={contactStyle}>
                            <i><a href="tel://16172337006" id="telLink">+1 617 233 7006</a></i>
                            <span className="fa fa-phone ml-2" />
                        </p>
                        <p className="instagram" style={contactStyle}>
                            <i><a href="https://www.instagram.com/toddlerdanceparty/" id="telLink">Instagram</a></i>
                            <span className="fa fa-instagram ml-2" />
                        </p>
                        <div className={largescreen ? "" : "mb-0"} style={contactStyle}>
                            <span id="userNameDisplay">{props.user.firstname ? "Welcome, " + props.user.firstname : null}&nbsp;</span>
                            <span id="userModeDisplay">{props.gameTime.userMode ? props.gameTime.userMode  + " mode" : null}</span>
                        </div>
                    </div>
                </div>

                {nav}
            </div>
        )
    }
    // else{
    //     return (
    //         <header id="kidslifeheader">
    //             <div style={{paddingLeft:10,paddingRight:10,width:'100%',display:'grid',placeItems:'center'}}>
    //                 <img onClick={()=>goHome()} src={contentURL() + "/site/images/TDPLogo.png"} alt="Toddler Dance Party!" title="Toddler Dance Party" id="headerImage" />
    //             </div>
    //             <div style={{textAlign:'center'}}>
    //                 <a href="mailto:dan@toddlerdanceparty.com" id="contactEmail">dan@toddlerdanceparty.com</a><span className="fa fa-envelope ml-2" />
    //
    //                 <br/>
    //
    //                 <i><a href="tel://16172337006" id="telLink">+1 617 233 7006</a></i><span className="fa fa-phone ml-2" />
    //
    //                 <div style={contactStyle}>
    //                     <span id="userNameDisplay">{props.user.firstname ? "Welcome, " + props.user.firstname : null}&nbsp;</span>
    //                     <span id="userModeDisplay">{props.gameTime.userMode ? props.gameTime.userMode  + " mode" : null}</span>
    //                 </div>
    //                 {nav}
    //             </div>
    //             <div id="menu-container">
    //             </div>
    //         </header>
    //     )
    // }
    else{
        return (
            <div style={{width:'100%',height:45,display:'grid',placeItems:'center',position:'relative',
                            background:'white url(images/mobile-header-bg.png) no-repeat center bottom',
                            borderBottom:'solid 1px #cccccc',
                            boxShadow:'0px 6px 45px -8px rgba(0,0,0,0.51)'
                        }}>
                <img src="images/tdp-mobile-logo.png" alt="TDP Logo" onClick={()=>goHome()}/>
                {nav2}
                <div ref={menuModalRef}
                    onClick={()=>killModal()}
                    style={{
                        width:'100vw',height:'100vh',position:'fixed',
                        top:0,left:0,background:'rgba(0,0,0,0.75)',
                        display:'none',placeItems:'center',
                        padding:'1rem',zIndex:1000
                    }}>
                    <SmallScreenMenuPage modalMode={true}/>
                </div>
            </div>
        )
    }
};

const mapStateToProps = (state) =>{
    return {
        user:state.user,
        gameTime:state.gameTime,
        appSetting:state.appSettings
    };
};

export default connect(mapStateToProps,{

})(KidsLifeHeader);
